module.exports = __webpack_public_path__ + "static/logo-fmd-book-series-64e75cf074ff9810b7e29f7b9fa38782.png";